import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=420f0b9b&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"
import style0 from "./Roles.vue?vue&type=style&index=0&id=420f0b9b&prod&scoped=true&lang=scss"
import style1 from "./Roles.vue?vue&type=style&index=1&id=420f0b9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420f0b9b",
  null
  
)

export default component.exports